import {
  getCurrentDistrictFromLocalStorage, getDistricts, saveNewDistrict,
  storeCurrentDistrictInLocalStorage, updateDistrict,
} from "../api/districts";
import {validateDistrictForm} from "../utils/districts";
import {MESSAGES} from "../constants";
import {updateSessionId} from "./session";

const initialState = {
  currentDistrict: null,
  addDistrictErrors: {},
  addDistrictAlert: null,
  addDistrictApiError: null,
  editDistrictErrors: {},
  editDistrictAlert: null,
  editDistrictApiError: null,
  currentDistrictSelected: false
};

export const storeDistricts = (districts) => {
  return {
    type: 'districts/storeDistricts',
    payload: districts
  }
}
export const changeCurrentDistrict = (selectedDistrict) => {
  storeCurrentDistrictInLocalStorage(selectedDistrict);
  return {
    type: 'districts/changeCurrentDistrict',
    payload: selectedDistrict
  }
}

export const restoreCurrentDistrictFromLocalStorage = () => {
  const currentDistrict = getCurrentDistrictFromLocalStorage();

  return {
    type: 'districts/restoreCurrentDistrictFromLocalStorage',
    payload: currentDistrict
  };
}

export const fetchDistricts = () => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  try {
    const results = await getDistricts(queryParams);

    await dispatch(updateSessionId(results[0].loggedInUserSessionId));

    await dispatch({
      type: 'districts/districtsFetched',
      payload: results
    });

  } catch (error) {
    dispatch({
      type: 'districts/fetchDistrictsFailed',
      payload: error
    });
  }
}


export const addDistrict = (name, externalId) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  const formErrors = validateDistrictForm(name, externalId);

  if (formErrors) {
    dispatch({
      type: 'districts/addDistrictFailedValidation',
      payload: formErrors
    });

    return null;
  }

  try {
    const response = await saveNewDistrict(name, externalId, queryParams);

    if (response === 'Failed to Add New District') {
      dispatch({
        type: 'districts/addDistrictFailedApi',
        payload: MESSAGES.DISTRICTS.error
      })
    } else {
      dispatch({
        type: 'districts/addDistrictSucceeded',
        payload: MESSAGES.DISTRICTS.addSuccess
      });
    }
    dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (error) {
    dispatch({
      type: 'districts/addDistrictFailedApi',
      payload: MESSAGES.DISTRICTS.error
    });
  }
}

export const saveDistrict = (districtForm, district) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  const formErrors = validateDistrictForm(districtForm.name, districtForm.externalId);

  if (formErrors) {
    dispatch({
      type: 'districts/editDistrictFailedValidation',
      payload: formErrors
    });

    return null;
  }

  function prepareDistrictObject() {
    district.name = districtForm.name;
    district.externalId = districtForm.externalId;
  }

  try {
    prepareDistrictObject();
    const response = await updateDistrict(district, queryParams);

    if (response === 'Failed to Update District') {
      dispatch({
        type: 'districts/editDistrictFailedApi',
        payload: MESSAGES.DISTRICTS.error
      })
    } else {
      await storeCurrentDistrictInLocalStorage(district);

      dispatch({
        type: 'districts/editDistrictSucceeded',
        payload: {
          district: district,
          successMessage: MESSAGES.DISTRICTS.updateSuccess
        }
      });
    }
    dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (error) {
    dispatch({
      type: 'districts/editDistrictFailedApi',
      payload: MESSAGES.DISTRICTS.error
    });
  }
}


export const clearAddDistrictAlert = () => {
  return {
    type: 'districts/clearAddDistrictAlert'
  }
}

export const clearAddDistrictErrors = () => {
  return {
    type: 'districts/clearAddDistrictErrors'
  }
}

export const clearEditDistrictAlert = () => {
  return {
    type: 'districts/clearEditDistrictAlert'
  }
}

export const clearEditDistrictErrors = () => {
  return {
    type: 'districts/clearEditDistrictErrors'
  }
}


export const clearCurrentDistrictSelected = () => {
  return {
    type: 'districts/clearCurrentDistrictSelected'
  }
}

export default function districtsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'districts/districtsFetched':
      return {
        ...state,
        districts: payload
      }
    case 'districts/fetchDistrictsFailed':
      return {
        ...state,
        fetchDistrictsError: payload
      }
    case 'districts/changeCurrentDistrict':
      return {
        ...state,
        currentDistrict: payload,
        currentDistrictSelected: true
      };
    case 'districts/restoreCurrentDistrictFromLocalStorage':
      return {
        ...state,
        currentDistrict: payload
      }
    case 'districts/addDistrictFailedValidation':
      return {
        ...state,
        addDistrictErrors: payload
      }
    case 'districts/addDistrictFailedApi':
      return {
        ...state,
        addDistrictApiError: payload
      }
    case 'districts/addDistrictSucceeded':
      return {
        ...state,
        addDistrictAlert: payload,
        addDistrictApiError: null,
        addDistrictErrors: null
      }
    case 'districts/clearAddDistrictAlert':
      return {
        ...state,
        addDistrictAlert: null,
        addDistrictErrors: null,
        addDistrictApiError: null
      }
    case 'districts/clearAddDistrictErrors':
      return {
        ...state,
        addDistrictApiError: null,
        addDistrictErrors: null
      }
    case 'districts/editDistrictFailedValidation':
      return {
        ...state,
        editDistrictErrors: payload
      }
    case 'districts/editDistrictFailedApi':
      return {
        ...state,
        editDistrictApiError: payload
      }
    case 'districts/editDistrictSucceeded':
      return {
        ...state,
        editDistrictAlert: payload.successMessage,
        currentDistrict: payload.district,
        editDistrictApiError: null,
        editDistrictErrors: null
      }
    case 'districts/clearEditDistrictAlert':
      return {
        ...state,
        editDistrictAlert: null,
        editDistrictErrors: null,
        editDistrictApiError: null
      }
    case 'districts/clearEditDistrictErrors':
      return {
        ...state,
        editDistrictApiError: null,
        editDistrictErrors: null
      }
    case 'districts/clearCurrentDistrictSelected':
      return {
        ...state,
        currentDistrictSelected: false
      }
    default:
      return state;
  }
}